import { render, staticRenderFns } from "./ShowInfo.vue?vue&type=template&id=53e14300&"
import script from "./ShowInfo.vue?vue&type=script&lang=js&"
export * from "./ShowInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports